import { styled } from '@mui/material';

/** 항목 라벨 / 값 2열 표. 값은 우측 정렬 */
export const InfoTableRoot = styled('table')`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-top: 1px solid var(--dk-line, #e7e9ec);
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  line-height: 24px;

  & th,
  & td {
    padding: 12px 16px;
    border-bottom: 1px solid var(--dk-line, #e7e9ec);
    vertical-align: middle;
  }

  & th {
    text-align: left;
    font-weight: 500;
    color: var(--dk-text-strong, #4d5157);
    background-color: var(--dk-bg-subtle, #f9fafb);
  }

  & td {
    text-align: right;
    font-weight: 400;
    color: var(--dk-text, #1d2025);
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

export const InfoTableEmphasis = styled('span')`
  font-weight: 600;
  color: var(--dk-accent, #0066cc);
`;
